import "leaflet/dist/leaflet.css";
import { css } from "@emotion/react";
import { useAlert } from "react-alert";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Circle,
  FeatureGroup,
  LayerGroup,
  MapContainer,
  Marker,
  Polyline,
  Popup,
  Rectangle,
  TileLayer,
  useMap,
  LayersControl,
} from "react-leaflet";
import Button from "@material-tailwind/react/Button";
import Description from "./Description";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
const center = [51.505, -0.09];
const rectangle = [
  [51.49, -0.08],
  [51.5, -0.06],
];
export default function HeaderSqMap(props) {
  const alert = useAlert();
  let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
  });

  const [position, setPosition] = useState(props.positionGlobal1);
  const [clicked, setclicked] = useState(false);
  const [tileSizeKm, settileSizeKm] = useState(0);
  const [keyMAP, setkeyMAP] = useState(1);
  const [gridLines, setgridLines] = useState(multiPolyline);

  useEffect(async () => {
    tileIt();
    let pos =
      props.positionGlobal1.lat.toFixed(2) +
      "," +
      props.positionGlobal1.lng.toFixed(2);
  }, [position]);

  function MyComponent() {
    const map = useMap();
    console.log(" from MyComponent map center:", map.getCenter());
    if (clicked) {
      map.flyTo(position, 14);
      setclicked(false);
    }
    return null;
  }

  function LocationMarker() {
    const markerRef = useRef(null);

    const eventHandlers = useMemo(
      () => ({
        dragend() {
          const marker = markerRef.current;
          if (marker != null) {
            setPosition(marker.getLatLng());
            // props.handleCallback1(marker.getLatLng());
            // tileIt();
          }
        },
      }),
      []
    );
    return position === null ? null : (
      <Marker
        position={position}
        icon={DefaultIcon}
        draggable={true}
        eventHandlers={eventHandlers}
        ref={markerRef}
        iconSize={[35, 46]}
        iconAnchor={[17, 46]}
      >
        <Popup> </Popup>
        <Popup minWidth={90}>
          Your§ kml centre will be on {position.lat} {","} {position.lng}
        </Popup>
      </Marker>
    );
  }

  const positionget = async () => {
    await navigator.geolocation.getCurrentPosition(
      (position1) => {
        console.log(position1.coords);
        var mypos = { lat: 99.41781926152715, lng: 21.042068918181126 };
        mypos.lat = position1.coords.latitude;
        mypos.lng = position1.coords.longitude;
        setPosition(mypos);
        setclicked(true);
      },
      (err) => console.log(err)
    );
  };
  const CIRCUMFERENCE_OF_THE_EARTH = 40075; // km
  const TILES = 2 ** 14;
  const KM_TO_MILES = 0.62137;

  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }

  function tileIt() {
    // Size = Circumference of Earth * cos(latitude) / 2^14
    let km =
      (CIRCUMFERENCE_OF_THE_EARTH * Math.cos(toRadians(position.lat))) / TILES;
    let miles = (km * KM_TO_MILES).toFixed(2);
    km = km.toFixed(2);
    settileSizeKm(km);
    console.log(km);
    console.log(miles);
  }

  const multiPolyline = [
    [
      [51.408, 21],
      [51.408, 22],
    ],
    [
      [52, 21],
      [52, 22],
    ],
    [
      [51, 21],
      [52, 21],
    ],
    [
      [51, 22],
      [52, 22],
    ],
  ];

  // https://leafletjs.com/reference-1.2.0.html#path-dasharray
  const limeOptions = { color: "red", weight: "1", opacity: "0.4" };

  const TestLayer = () => {
    const map = useMap();

    if (map.getZoom() < 9) {
      // alert.show("Please zoom in to see a grid");
      return null;
    }
    console.log("fromTestLayer: ", "");
    console.log("NW: ", map.getBounds().getNorthWest());
    console.log("SE: ", map.getBounds().getSouthEast());
    const nwt = calcTile(map.getBounds().getNorthWest());
    const set = calcTile(map.getBounds().getSouthEast());
    console.log("nwt: ", nwt);
    console.log("set: ", set);
    let multiPolylineGen = [];
    let i = nwt.x;

    // let line = [];
    for (let i = nwt.y; i <= set.y + 2; i++) {
      console.log("i: ", i);
      let polyline = [];
      let lineStart = [tile2lat(i - 1, 14), tile2long(nwt.x, 14)];
      polyline.push(lineStart);
      console.log("lineStart: ", lineStart);
      let lineEnd = [tile2lat(i - 1, 14), tile2long(set.x, 14)];
      polyline.push(lineEnd);
      console.log("lineEnd: ", lineEnd);
      multiPolylineGen.push(polyline);
    }
    for (let i = nwt.x; i <= set.x; i++) {
      console.log("i: ", i);
      let polyline = [];
      let lineStart = [tile2lat(nwt.y - 1, 14), tile2long(i, 14)];
      polyline.push(lineStart);
      console.log("lineStart: ", lineStart);
      let lineEnd = [tile2lat(set.y + 1, 14), tile2long(i, 14)];
      polyline.push(lineEnd);
      console.log("lineEnd: ", lineEnd);
      multiPolylineGen.push(polyline);
    }

    //
    // for (let i = nwt.y - 1; i <= set.x + 1; i++) {
    //   console.log("i: ", i);
    //   let polyline = [];
    //   let lineStart = [tile2lat(i - 1, 14), tile2long(nwt.x - 1, 14)];
    //   polyline.push(lineStart);
    //   console.log("lineStart: ", lineStart);
    //   let lineEnd = [tile2lat(i - 1, 14), tile2long(set.x + 1, 14)];
    //   polyline.push(lineEnd);
    //   console.log("lineEnd: ", lineEnd);
    //   multiPolylineGen.push(polyline);
    // }

    return (
      <Polyline
        key={keyMAP}
        pathOptions={limeOptions}
        positions={multiPolylineGen}
      />
    );
  };
  const deg2rad = function (degrees) {
    const pi = Math.PI;
    return degrees * (pi / 180);
  };

  const calcTile = function (item) {
    const x = Math.floor(((item.lng + 180) / 360) * Math.pow(2, 14));
    const y = Math.floor(
      ((1 -
        Math.log(
          Math.tan(deg2rad(item.lat)) + 1 / Math.cos(deg2rad(item.lat))
        ) /
          Math.PI) /
        2) *
        Math.pow(2, 14)
    );
    return {
      x: x,
      y: y,
    };
  };

  const tile2long = function (x, z) {
    return (x / Math.pow(2, z)) * 360 - 180;
  };
  /**
   * Calc tile 2 lat
   */
  const tile2lat = function (y, z) {
    const n = Math.PI - (2 * Math.PI * y) / Math.pow(2, z);
    return (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
  };

  function testClick() {
    setkeyMAP(Math.random());
  }

  return (
    <div className="relative pt-16 pb-32 flex content-center items-center justify-center h-screen">
      <div className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full" />
      <div className="container max-w-8xl flex-auto relative mx-auto">
        <div className="leaflet-container1">
          <MapContainer
            className="flex-auto leaflet-container1"
            center={position}
            zoom={9}
            scrollWheelZoom={true}
            doubleClickZoom={true}
            id="mapId"

            // ref="map"
          >
            {/*<TileLayer*/}
            {/*  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'*/}
            {/*  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
            {/*/>*/}
            {/*!!!!!!!*/}
            {/*http://leaflet-extras.github.io/leaflet-providers/preview/index.html*/}
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name="OpenStreetMap.Mapnik">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="OpenStreetMap.Topo">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="OpenStreetMap.Cycle">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenStreetMap.Earth">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenStreetMap.MTB">
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.Overlay name="Marker with popup">
                <Marker position={center}>
                  <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                  </Popup>
                </Marker>
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Layer group with circles">
                <LayerGroup>
                  <Circle
                    center={center}
                    pathOptions={{ fillColor: "blue" }}
                    radius={200}
                  />
                  <Circle
                    center={center}
                    pathOptions={{ fillColor: "red" }}
                    radius={100}
                    stroke={false}
                  />
                  <LayerGroup>
                    <Circle
                      center={[51.51, -0.08]}
                      pathOptions={{ color: "green", fillColor: "green" }}
                      radius={100}
                    />
                  </LayerGroup>
                </LayerGroup>
              </LayersControl.Overlay>
              <LayersControl.Overlay name="Feature group">
                <FeatureGroup pathOptions={{ color: "purple" }}>
                  <Popup>Popup in FeatureGroup</Popup>
                  <Circle center={[51.51, -0.06]} radius={200} />
                  {/*<Rectangle bounds={rectangle} />*/}
                </FeatureGroup>
              </LayersControl.Overlay>
            </LayersControl>
            <LocationMarker />
            {/*<Description*/}
            {/*  title={"My Button Title"}*/}
            {/*  markerPosition={[201.27, -157]}*/}
            {/*  description="This is a custom description!"*/}
            {/*/>*/}
            <MyComponent />
            <TestLayer key={keyMAP} />
          </MapContainer>
        </div>
        <div>
          <p style={{ color: "white" }}>
            On {position.lat.toFixed(3)} {","}
            {position.lng.toFixed(3)} Square size is {tileSizeKm} [km]{"="}
            {(tileSizeKm * KM_TO_MILES).toFixed(2)}[miles1]
            Square Numbers is :
          </p>

          {/*<Button*/}
          {/*  onClick={positionget}*/}
          {/*  color="lightBlue"*/}
          {/*  ripple="light"*/}
          {/*  className=" mr-2"*/}
          {/*>*/}
          {/*  Get Your Location*/}
          {/*</Button>*/}
          {/*<Button*/}
          {/*  onClick={testClick}*/}
          {/*  color="lightBlue"*/}
          {/*  ripple="light"*/}
          {/*  className=" mr-2"*/}
          {/*>*/}
          {/*  testClick*/}
          {/*</Button>*/}
        </div>
        <a
          href="https://rideeverytile.com/tiles/how_big_is_a_tile"
          target="_blank"
          rel="noreferrer"
        >
          RideEveryTile: How big is a tile?
        </a>
        {/*</div>*/}
      </div>
    </div>
  );
}
